var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stripe-card-list"},[_c('list',{ref:"stripeCardList",attrs:{"fs":_vm.stripeCardFields,"api":"stripe/cards","title":"Cards","beforeDelete":_vm.handleBeforeDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }